// 审核状态
export enum ApprovalStatus {
  SUBMITTING = "SUBMITTING", // '授信中',
  SUCCEEDED = "SUCCEEDED", // '授信成功',

  REJECT = "REJECT", // '授信拒绝',
  FAILED = "FAILED", // ,'授信失败',
  EXCEPTION = "EXCEPTION", // '授信异常',

  OVERDUE = "OVERDUE", // '授信过期',
  FROZEN = "FROZEN", // 冻结
}
